export default {
  USER_REQUESTS_REPORT_ID: 1,
  PROJECT_REQUESTS_REPORT_ID: 2,
  RECONCILIATION_REPORT_ID: 3,
  TICKET_REQUEST_FINANCE_REPORT_ID: 4,
  SEASON_TICKETS: 5,
  REQUESTS_BY_VENUE: 6,
  CLOSE_CUTOFF: 7,
  TODAYS_TICKETS: 8,
  PURCHASE_OPP_FINANCE_REPORT_ID: 9,
  DIGITAL_TICKETS_REPORT_ID: 10,
  REQUEST_COUNTS_REPORT_ID: 11,
};
